<div class="sign-up-email">
  <ng-container [ngSwitch]="state">
    <section *ngSwitchCase="SignupEmailState.InputEmail" class="email-container">
      <div class="title">
        <mat-icon (click)="back()" class="back-btn">arrow_back_ios</mat-icon>
        <h1>Sign up</h1>
      </div>
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input (keyup.enter)="verifyEmail(SpinnerType.Verifying)" [formControl]="emailCtrl" matInput />
      </mat-form-field>
      <button
        (click)="verifyEmail(SpinnerType.Verifying)"
        [disabled]="emailCtrl.invalid"
        [loading]="spinner[SpinnerType.Verifying]"
        color="primary"
        mat-flat-button
      >
        Next
      </button>

      <div class="has-account">
        <div>Already have an account?</div>
        <button (click)="navigate2Login()" color="primary" mat-button>Sign in</button>
      </div>
    </section>

    <section *ngSwitchCase="SignupEmailState.InputCode" class="code-container">
      <h1 class="title">Check your email!</h1>

      <div>An email message with your code has been sent to</div>
      <div class="email">{{ emailCtrl?.value }}</div>
      <button
        (click)="verifyEmail(SpinnerType.Resending)"
        [loading]="spinner[SpinnerType.Resending]"
        class="resend-btn"
        color="primary"
        mat-button
      >
        Didn't receive the message?
      </button>
      <mat-form-field class="w-full">
        <mat-label>Verification code</mat-label>
        <span class="font-550" matPrefix>{{ sanitizedCode }} &nbsp; - </span>
        <input [formControl]="codeCtrl" matInput />
      </mat-form-field>
      <button
        (click)="verify2FA()"
        [disabled]="codeCtrl.invalid"
        [loading]="spinner[SpinnerType.Verifying]"
        class="next-btn"
        color="primary"
        mat-flat-button
      >
        Next
      </button>
    </section>

    <section *ngSwitchCase="SignupEmailState.Exist" class="exist-container">
      <h1 class="title">Sign up</h1>
      <div class="message">
        An account with email <span class="font-550">{{ emailCtrl?.value }}</span> already exists.
      </div>
      <button (click)="navigate2Login()" class="w-full" color="primary" mat-flat-button>Back to sign in</button>
    </section>
  </ng-container>
</div>
